// Configuration centrale du magnétisme et des guides d'alignement.
// Un seul point d'entrée : aucun autre module du dossier ne code de constante
// visuelle ou de seuil en dur.
//
// Unités :
// - snapThreshold / strokeWidth / guideOverhang sont exprimés en PIXELS ÉCRAN
//   et divisés par le facteur de zoom au moment de l'usage (cf. snapSession /
//   SnapGuidesOverlay). Sinon le magnétisme deviendrait deux fois plus mou à
//   50 % de zoom qu'à 100 %, alors que la sensation doit rester la même.
// - toutes les autres coordonnées manipulées par le moteur sont en pixels
//   « document » (non zoomés), le même espace que box.left / box.top.
export const SNAP_CONFIG = {
  enabled: true,
  // Distance d'accrochage (px écran). 4 = discret, 8 = très collant.
  snapThreshold: 6,
  enableHaptics: true,
  // Durée de l'impulsion haptique (ms) passée à navigator.vibrate.
  hapticPattern: 8,
  // Silence minimal entre deux impulsions : empêche le moteur haptique de
  // s'emballer quand la box tremble autour d'un seuil.
  hapticCooldown: 120,
  // Gris ardoise : neutre sur une page de proposition, où les couleurs vives
  // entreraient en concurrence avec le contenu. Bords et centres se
  // distinguent par la VALEUR (le centre est plus sombre), pas par la teinte —
  // ça reste lisible en niveaux de gris et sur fond de page coloré.
  guideColor: '#6B7280',
  guideCenterColor: '#111827',
  // Gris plus discret que du magenta : l'opacité peut monter sans agresser.
  guideOpacity: 0.85,
  strokeWidth: 1,
  // Dépassement du trait de part et d'autre des deux box alignées.
  guideOverhang: 8,
  // Nombre de traits simultanés par axe (gauche / centre / droite).
  maxGuidesPerAxis: 3,
  // Grands documents : on ignore les box hors écran comme cibles d'alignement.
  viewportCulling: true,
  // Marge (px écran) autour du viewport conservée malgré le culling.
  viewportMargin: 200,
};

// Permet à une future UI (ou à un test) de changer un réglage sans recharger :
// les modules lisent SNAP_CONFIG à l'usage, jamais par copie à l'import.
export const setSnapConfig = (partial) => Object.assign(SNAP_CONFIG, partial);
